import {
  Grid,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  CircularProgress,
} from '@mui/material'
import { useState } from 'react'
import { metodoPrograma } from '../../../components/api'

const ModalProcessaPagamento = ({ close }) => {
  const [dataInicial, setDataInicial] = useState('')
  const [dataFinal, setDataFinal] = useState('')
  const [loading, setLoading] = useState(false)

  const handleFalse = () => {
    close(false)
  }

  const confirmaPagamento = async () => {
    setLoading(true)
    const values = {
      dtInicial: dataInicial,
      dtFinal: dataFinal,
    }
    const res = await metodoPrograma('processaComissao', values)
    if (res.status) handleFalse()
    setLoading(false)
  }

  return (
    <Dialog maxWidth="lg" open={true} onClose={handleFalse}>
      <DialogTitle divider>Processar Pagamento de Comissão</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Referência Inicial"
              type="date"
              margin="dense"
              variant="outlined"
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={dataInicial}
              onChange={(e) => setDataInicial(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Referência Final"
              type="date"
              margin="dense"
              variant="outlined"
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={dataFinal}
              onChange={(e) => setDataFinal(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              onClick={confirmaPagamento}
              disabled={loading}
              endIcon={
                loading ? <CircularProgress color="grey" size={15} /> : null
              }
            >
              Processar resumo de pagamento
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalProcessaPagamento
